/*
  Diamanthuset – nyhetsbrev-påmelding routes to Klaviyo (client subscribe API).
  Email subscribed to single-opt-in list VvKGGb -> fires "Subscribed to Email
  Marketing" -> triggers welcome flow U6QXuq (kode 15diamanter).
  Phone captured when provided (E.164). SMS marketing consent set only when the
  consent box is ticked -> welcome flow's SMS leg also sends.
  Popup form has a REQUIRED phone (input[required]); validated here because we
  intercept submit (native required validation would be bypassed).
  Covers footer form, popup (overlay-newsletter) and any newsletter section.
*/
!(function () {
  "use strict";
  var COMPANY = "XmTtHk";
  var LIST_ID = "VvKGGb";
  var REVISION = "2025-07-15";
  var FORM_SEL = "[data-newsletter-form]";
  var ENDPOINT =
    "https://a.klaviyo.com/client/subscriptions/?company_id=" +
    encodeURIComponent(COMPANY);
  var SUCCESS_MSG =
    "Takk for påmeldingen! Vi har sendt deg en e-post med din -15 % rabattkode. Sjekk innboksen (og eventuelt søppelpost).";
  var ERROR_MSG =
    "Noe gikk galt – prøv igjen, eller kontakt kundeservice@diamanthuset.no.";
  var PHONE_MSG = "Skriv inn et gyldig mobilnummer.";
  var CONSENT_MSG = "Kryss av for å bli med og motta tilbudet.";

  function post(profileAttrs) {
    var body = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Nyhetsbrev nettside",
          profile: { data: { type: "profile", attributes: profileAttrs } },
        },
        relationships: { list: { data: { type: "list", id: LIST_ID } } },
      },
    };
    return fetch(ENDPOINT, {
      method: "POST",
      headers: { revision: REVISION, "content-type": "application/json" },
      body: JSON.stringify(body),
    });
  }

  // Normalise a Norwegian/international number to E.164, or null if implausible.
  function toE164(raw) {
    if (!raw) return null;
    var s = ("" + raw).replace(/[^\d+]/g, "");
    if (s.charAt(0) === "+") return s.length >= 9 ? s : null;
    s = s.replace(/^00/, "");
    if (s.indexOf("47") === 0 && s.length === 10) return "+" + s;
    if (s.length === 8) return "+47" + s; // NO mobile without country code
    if (s.length >= 9) return "+" + s;
    return null;
  }

  if (customElements.get("newsletter-component")) return;

  customElements.define(
    "newsletter-component",
    class extends HTMLElement {
      connectedCallback() {
        if (window.location.pathname === "/challenge") return;
        this.form = this.querySelector(FORM_SEL);
        if (!this.form) return;
        this.form.addEventListener("submit", this.onSubmit.bind(this));
      }

      onSubmit(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var self = this;
        var form = this.form;

        var emailEl =
          form.querySelector("[data-newsletter-field]") ||
          form.querySelector("input[type=email]") ||
          form.querySelector("input[name='contact[email]']");
        var email = emailEl && emailEl.value ? emailEl.value.trim() : "";
        if (!email || email.indexOf("@") < 1) {
          this.showError();
          if (emailEl) emailEl.focus();
          return;
        }

        var phoneEl =
          form.querySelector("[data-newsletter-phone]") ||
          form.querySelector("input[type=tel]");
        var rawPhone = phoneEl && phoneEl.value ? phoneEl.value.trim() : "";
        var e164 = rawPhone ? toE164(rawPhone) : null;
        var phoneRequired = !!(phoneEl && phoneEl.hasAttribute("required"));
        if (phoneRequired && !e164) {
          this.showError(PHONE_MSG);
          if (phoneEl) phoneEl.focus();
          return;
        }

        var consentBox = form.querySelector("[data-marketing-consent]");
        if (consentBox && !consentBox.checked) {
          this.showError(CONSENT_MSG);
          if (consentBox.focus) consentBox.focus();
          return;
        }

        var attrs = {
          email: email,
          subscriptions: { email: { marketing: { consent: "SUBSCRIBED" } } },
        };
        if (e164) attrs.phone_number = e164; // capture phone whenever valid
        if (e164 && consentBox && consentBox.checked)
          attrs.subscriptions.sms = { marketing: { consent: "SUBSCRIBED" } };
        var nameEl = form.querySelector("input[name='contact[first_name]']");
        if (nameEl && nameEl.value) attrs.first_name = nameEl.value.trim();

        var btn = form.querySelector("button[type=submit]");
        if (btn) btn.disabled = true;
        post(attrs)
          .then(function (r) {
            if (r && r.status >= 200 && r.status < 300) self.showSuccess();
            else self.showError();
          })
          .catch(function () {
            self.showError();
          })
          .then(function () {
            if (btn) btn.disabled = false;
          });
      }

      showSuccess() {
        var form = this.form;
        form.classList.remove("has-error");
        form.classList.add("has-success");
        Array.prototype.forEach.call(
          form.querySelectorAll(
            ".input-group, .input-row, .form__legal, .newsletter__sms-consent"
          ),
          function (el) {
            el.style.display = "none";
          }
        );
        var msg = form.querySelector(".newsletter__message--success");
        if (!msg) {
          msg = document.createElement("p");
          msg.className = "newsletter__message newsletter__message--success";
          form.insertBefore(msg, form.firstChild);
        }
        msg.textContent = SUCCESS_MSG;
        msg.style.display = "block";
        var heading =
          this.parentElement &&
          this.parentElement.querySelector("[data-newsletter-heading]");
        if (heading) heading.classList.add("hidden");
      }

      showError(message) {
        var form = this.form;
        form.classList.remove("has-success");
        form.classList.add("has-error");
        var err = form.querySelector(".newsletter__message--error");
        if (err) {
          err.innerHTML = "<em>" + (message || ERROR_MSG) + "</em>";
          err.style.display = "block";
        }
      }
    }
  );
})();
